// Envelope / row -> CSV utilities.
import { valueLabel, formatDuration } from "../reports/format";

const esc = (v) => {
   if (v === null || v === undefined) return "";
   const s = String(v);
   return /[",\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
};

// Mirror ReportRunner cell formatting so the CSV carries front-facing values
// (labels, humanized duration, percent) rather than raw backend enums/seconds.
// Money stays a plain number for spreadsheet re-import.
const csvValue = (c, v) => {
   if (c.type === "label") return valueLabel(c.key, v);
   if (c.type === "duration") return formatDuration(v);
   if (c.type === "percent") return v == null || v === "" ? "" : `${v}%`;
   return v;
};

// New: export using already-filtered rows + visible column objects (in order).
// This is the preferred export path from ReportRunner.
export function rowsToCsv(rows, columns) {
   const header = columns.map((c) => esc(c.label)).join(",");
   const lines = [header];
   for (const row of rows) {
      lines.push(columns.map((c) => esc(csvValue(c, row[c.key]))).join(","));
   }
   return lines.join("\n");
}

// Legacy: kept for any callers that still pass the full envelope + definition.
export function envelopeToCsv(envelope, definition) {
   const cols = definition.columns;
   const rows = (envelope.groups || []).flatMap((g) => g.rows || []);
   return rowsToCsv(rows, cols);
}

export function downloadCsv(filename, csv) {
   const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
   const url = URL.createObjectURL(blob);
   const a = document.createElement("a");
   a.href = url; a.download = filename;
   document.body.appendChild(a); a.click(); a.remove();
   URL.revokeObjectURL(url);
}
